import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { toast } from "react-toastify";
import useStyles from "../../../../styles";
import TableView from "../../../CustomComponent/TableView";
import axios from "axios";
import { decryptData } from "../../../../crypto";

function SubjectSubmitDialog({ open, onClose, userId, examId, onStatusUpdate, studentName, rollNumber }) {
  const classes = useStyles();
  const [subjectData, setSubjectData] = useState([]);
  const [rowDurations, setRowDurations] = useState({});

  useEffect(() => {
    const fetchSubjectData = async () => {
      try {
        const decryptedToken = decryptData(sessionStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/learner/subject_submit/?user_id=${userId}&exam_id=${examId}`,
          {
            headers: { Authorization: `Bearer ${decryptedToken}` },
          }
        );
        if (response.data.success) {
          const formattedData = (response.data.subjects || []).map((subject) => ({
            ...subject,
            id: subject.subject_id, // TableView requires 'id'
          }));
          setSubjectData(formattedData);
        }
      } catch (error) {
        console.error("Error fetching subject data:", error);
      }
    };

    if (open && userId && examId) {
      fetchSubjectData();
      setRowDurations({});
    }
  }, [open, userId, examId]);

  const handleRowSubmit = async (row) => {
    const rowDuration = rowDurations[row.id];
    if (!rowDuration) {
      toast.warning(`Please enter duration for ${row.subject_name}`);
      return;
    }

    const totalSeconds = parseInt(rowDuration, 10) || 0;

    if (isNaN(totalSeconds) || totalSeconds <= 0) {
      toast.warning("Duration must be greater than 0");
      return;
    }

    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/learner/update/time`,
        {
          user_id: userId,
          exam_id: examId,
          subject_id: row.subject_id,
          new_time: totalSeconds,
        },
        {
          headers: { Authorization: `Bearer ${decryptedToken}` },
        }
      );

      if (response.data.success) {
        toast.success(response.data.message || "Time updated successfully");
        if (onStatusUpdate) {
          onStatusUpdate(userId, "Not giving");
        }
        onClose(); 
      } else {
        toast.error(response.data.message || "Failed to update time");
      }
    } catch (error) {
      console.error("Error updating time:", error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };


  const columns = [
    {
      field: "id",
      headerName: "Sr.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const rows = subjectData;
        const index = rows.findIndex((row) => row.id === params.row.id);
        return <span>{index + 1}</span>;
      },
    },
    {
      field: "subject_name",
      headerName: "Subject Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 280,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "all_attempted_count",
      headerName: "Attempted Question",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 130,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "remaining_time",
      headerName: "Remaining Time",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 150,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "submit_time",
      headerName: "Submitted Time",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 170,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (!params.value || params.value === "-") return "-";
        try {
          const date = new Date(params.value);
          return date.toLocaleTimeString();
        } catch (e) {
          return params.value;
        }
      }
    },
    {
      field: "action_duration",
      headerName: "Duration (Seconds)",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 140,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isLast = subjectData.findIndex(s => s.id === params.row.id) === subjectData.length - 1;
        return (
          <TextField
            size="small"
            variant="outlined"
            placeholder="Sec"
            disabled={!isLast}
            value={rowDurations[params.row.id] || ""}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*$/.test(val)) {
                setRowDurations(prev => ({ ...prev, [params.row.id]: val }));
              }
            }}
            style={{ width: "100px" }}
          />
        );
      }
    },
    {
      field: "action_restart",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isLast = subjectData.findIndex(s => s.id === params.row.id) === subjectData.length - 1;
        return (
          <Button
            variant="contained"
            size="small"
            disabled={!isLast}
            style={{ 
              background: isLast ? "#146A8E" : "#ccc", 
              color: "white", 
              fontSize: "12px", 
              padding: "6px 12px" 
            }}
            onClick={() => handleRowSubmit(params.row)}
          >
            Restart
          </Button>
        );
      }
    },
  ];

  const Heading = [
    {
      style: "viewtable",
      // checkboxselection: "false",
      height: "h320px", 
    },
  ];



  return (
    <Dialog 
      open={open} 
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      disableEscapeKeyDown
      PaperProps={{ style: { width: "1100px", maxWidth: "none", borderRadius: "4px" } }}
    >
      <DialogTitle style={{ background: "#146A8E", color: "white", padding: "12px 24px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              Subject Submit
            </Typography>
            {studentName && (
              <Typography variant="body2" style={{ opacity: 0.9, marginTop: "4px" }}>
                Roll No: {rollNumber} | Name: {studentName}
              </Typography>
            )}
          </div>
          <IconButton
            aria-label="close"
            onClick={onClose}
            style={{ color: "white", padding: "8px" }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: "20px" }}>
        <div style={{ width: "100%" }}>
          <TableView
            columns={columns}
            rows={subjectData}
            Heading={Heading}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "16px" }}>
        <Button onClick={onClose} className={classes.custombtnoutline}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SubjectSubmitDialog;
